// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__M-FUL","spin":"loader_spin__u99fp"};